import { render, staticRenderFns } from "./publisher.vue?vue&type=template&id=1e597a4c&"
import script from "./publisher.vue?vue&type=script&lang=js&"
export * from "./publisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports